import { render, staticRenderFns } from "./DeviceDashboard.vue?vue&type=template&id=f531e07a&"
import script from "./DeviceDashboard.vue?vue&type=script&lang=js&"
export * from "./DeviceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports